import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ExternalStudentInputForm from '../../views/Public/ExternalStudentForms/ExternalStudentInputForm';
import Landing from '../../views/Public/Landing/Landing';
import MobileLanding from '../../views/Public/MobileLanding/MobileLanding';
import PrivacyPolicy from '../../views/Public/PrivacyPolicy/PrivacyPolicy';
import UnderConstruction from '../../views/Public/UnderConstruction/UnderConstruction';

// Privremeno: landing stranice su sakrivene dok se ne objavi mobilna aplikacija.
// Za vracanje pravih stranica postaviti na false.
const UNDER_CONSTRUCTION = true;

export default function Public() {
    return (
        <div className="app">
            <Switch>
                <Route
                    path="/public/external-student-form/:code"
                    component={ExternalStudentInputForm}
                />
                <Route
                    path="/public/landing"
                    component={UNDER_CONSTRUCTION ? UnderConstruction : Landing}
                />
                <Route
                    path="/public/mobile"
                    component={UNDER_CONSTRUCTION ? UnderConstruction : MobileLanding}
                />
                <Route
                    path="/public/privacy-policy"
                    component={PrivacyPolicy}
                />
            </Switch>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/containers/Public/Public.js